var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgApple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1503 10.534C16.1415 8.90076 16.8703 7.668 18.3456 6.76012C17.5201 5.56297 16.2732 4.90432 14.6268 4.77526C13.0682 4.65065 11.3646 5.69648 10.7412 5.69648C10.0826 5.69648 8.57229 4.81976 7.38685 4.81976C4.93695 4.85981 2.33337 6.80018 2.33337 10.7477C2.33337 11.9137 2.54412 13.1182 2.96561 14.3614C3.52759 15.9947 5.55601 20 7.67223 19.9332C8.77864 19.9065 9.56015 19.1366 11.0002 19.1366C12.3964 19.1366 13.1209 19.9332 14.3546 19.9332C16.4884 19.9021 18.3236 16.2617 18.8592 14.6239C15.9966 13.2577 16.1503 10.6186 16.1503 10.534ZM13.6653 3.22652C14.8639 1.7846 14.7541 0.47174 14.719 0C13.6609 0.0623053 12.4359 0.729862 11.7378 1.55318C10.9695 2.43436 10.5173 3.5247 10.6139 4.753C11.7598 4.84201 12.8047 4.24566 13.6653 3.22652Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgApple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Apple.6e66c961e53499ce6c630d9036c8a43e.svg";